import { render } from "./GeneralInformation.vue?vue&type=template&id=52163c67&scoped=true"
import script from "./GeneralInformation.vue?vue&type=script&lang=js"
export * from "./GeneralInformation.vue?vue&type=script&lang=js"

import "./GeneralInformation.vue?vue&type=style&index=0&id=52163c67&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52163c67"]])

export default __exports__